import _URL from "@babel/runtime-corejs3/core-js/url";
export function redirect(url) {
  window.location.assign(url);
}
export function getUrlParam(param) {
  if (typeof window === 'undefined') return null;
  var url = new _URL(window.location.href);
  return url.searchParams.get(param);
}
export function getLocalStorageItem(key) {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(key);
}
export function setLocalStorageItem(key, value) {
  if (typeof window === 'undefined') return null;
  localStorage.setItem(key, value);
}
export function removeLocalStorageItem(key) {
  if (typeof window === 'undefined') return null;
  localStorage.removeItem(key);
}